
export default class Asset {
    constructor(assetManager) {
        this.assetManager = assetManager;
        this.id = "NONE";
        this.type = "NONE";
        this.name = "None";
        this.loaded = false;
    }

    load(id, url, onLoad, onError) {
        throw new Error("Can't load asset of type NONE.");
    }

    get() {
        return null;
    }
}
